import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=055b2902&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=055b2902&lang=scss&scoped=true"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=055b2902&lang=scss&scoped=true"
import style2 from "./orderDetail.vue?vue&type=style&index=2&id=055b2902&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b2902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055b2902')) {
      api.createRecord('055b2902', component.options)
    } else {
      api.reload('055b2902', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=055b2902&scoped=true", function () {
      api.rerender('055b2902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderDetail.vue"
export default component.exports